import React from "react";
import CommonNavbar from "../../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../../components/CommonFooter/CommonFooter";
import RefundPolicy from "../../components/Policy/RefundPolicy";

const RefundPolicyPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <RefundPolicy />
      <CommonFooter />
    </div>
  );
};

export default RefundPolicyPage;
